import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser, faSignOut, faUserCog } from '@fortawesome/sharp-solid-svg-icons';
import { Labels } from '@lib/sc-eone-ui/src/strings/strings-en-us';
import { Button } from 'eone-ui/buttons/button';
import { useNavigate } from 'react-router-dom';

import { SCToast } from '@lib/sc-eone-ui';

function ProfileButton(props) {
  const navigate = useNavigate();

  const logout = async () => {
    const response = await fetch('/home/logout');
    const responseJson = JSON.parse(await response.text());
    if (response.ok) window.location.href = responseJson.data;
    else {
      SCToast.error(responseJson.data);
    }
  };

  const gotoProfile = () => {
    navigate('/profile');
  };

  const getMenuItems = () => {
    if (props.IsEmbeddedApp || props.Disabled) {
      return [
        {
          Label: Labels.SignOut,
          Icon: faSignOut,
          OnClick: logout,
        },
      ];
    }
    return [
      {
        Label: Labels.EditProfile,
        Icon: faUserCog,
        OnClick: gotoProfile,
      },
      {
        Label: '-',
        Divider: true,
      },
      {
        Label: Labels.SignOut,
        Icon: faSignOut,
        OnClick: logout,
      },
    ];
  };

  const name = props.UserName ? props.UserName : props.Email;
  return (
    <div className="pd-app-header-profile">
      <FontAwesomeIcon color="white" icon={faCircleUser} />
      <Button Label={name} DataTestId={props.DataTestId} MenuItems={getMenuItems()} />
    </div>
  );
}

export { ProfileButton };
